/*
 * Copyright 2022 Adobe. All rights reserved.
 */

const clouds = ["Agreements and Contracts", "Content Publishing","Education","Human Resources", "Financial"];

const baseUrl = '/document-services';

// Important: lastUpdated date should be unique to ensure stable sort across browsers
const products = [
  {
    id: 0,
    name: "Agreement",
    description: "Adobe Creative Cloud APIs and SDKs enable developers",
    icon: `${baseUrl}/img/template-icons/agreement.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleagreement",
    docs: false,
    lastUpdated: "2020",
    cloud: clouds[0],
  },
  {
    id: 1,
    name: "Grant application",
    description: "The Libraries API lets you connect your app to Creative Cloud and expand the reach of your users' creative systems.",
    icon: `${baseUrl}/img/template-icons/grant_application.jpg`,
    discover: "https://www.adobe.com/go/dcdg_samplegrant",
    docs: false,
    lastUpdated: "2019",
    cloud: clouds[4],
  },
  {
    id: 2,
    name: "Invoice",
    description: "Adobe XD’s powerful API platform lets developers and users extend XD within the app, or in the cloud.",
    icon: `${baseUrl}/img/template-icons/invoice.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleinvoice",
    docs: false,
    lastUpdated: "2017",
    cloud: clouds[4],
  },
  {
    id: 3,
    name: "Sample proposal",
    description: "Give your users access to the perfect Adobe Stock",
    icon: `${baseUrl}/img/template-icons/proposal_letter.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleproposal",
    docs: false,
    lastUpdated: "2002",
    cloud: clouds[4],
  },
  {
    id: 4,
    name: "Certification report",
    description: "With Photoshop APIs and SDKs, build plugins and integrations that harness the power of the world's best image editing",
    icon: `${baseUrl}/img/template-icons/lms_report.jpg`,
    discover: "https://www.adobe.com/go/dcdg_samplereport",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },

  {
    id: 5,
    name: "Offer Letter",
    description: "Create effects, define presets and brushes, manipu",
    icon: `${baseUrl}/img/template-icons/offer_letter.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleofferletter",
    docs: false,
    lastUpdated: "1999",
    cloud: clouds[0],
  },
  {
    id: 6,
    name: "Sample Award Letter",
    description: "Create effects, define presets and brushes, manipu",
    icon: `${baseUrl}/img/template-icons/award_letter.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleawardletter",
    docs: false,
    lastUpdated: "1999",
    cloud: clouds[1],
  },
  {
    id: 7,
    name: "City Programs Sheet",
    description: "Create effects, define presets and brushes, manipu",
    icon: `${baseUrl}/img/template-icons/city_sheet.jpg`,
    discover: "https://www.adobe.com/go/dcdg_samplecityprogramsheet",
    docs: false,
    lastUpdated: "1999",
    cloud: clouds[1],
  },
  {
    id: 8,
    name: "LMS Certificate",
    description:"LMS Certificate",
    icon: `${baseUrl}/img/template-icons/lms_certificate.jpg`,
    discover: "https://www.adobe.com/go/dcdg_samplecertificate",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 9,
    name: "Sample Annual Report",
    description:"Sample Annual Report",
    icon: `${baseUrl}/img/template-icons/annual_report.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleannualreport",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 10,
    name: "Employee Handbook",
    description:"Sample Annual Report",
    icon: `${baseUrl}/img/template-icons/employee_handbook.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleemployeehandbook",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 10,
    name: "Remote Work",
    description:"Sample Annual Report",
    icon: `${baseUrl}/img/template-icons/employee_remote.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleremotework",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 11,
    name: "Marketing Data Sheet",
    description:"Marketing Data Sheet",
    icon: `${baseUrl}/img/template-icons/marketing_sheet.jpg`,
    discover: "https://www.adobe.com/go/dcdg_samplemarketingdatasheet",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 12,
    name: "Project Status Report",
    description:"Project Status Report",
    icon: `${baseUrl}/img/template-icons/project_status.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleprojectstatusreport",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 12,
    name: "Welcome Kit",
    description:"Welcome Kit",
    icon: `${baseUrl}/img/template-icons/welcome_kit.jpg`,
    discover: "https://www.adobe.com/go/dcdg_samplewelcomekit",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 13,
    name: "Receipt",
    description:"Receipt",
    icon: `${baseUrl}/img/template-icons/service_receipt.jpg`,
    discover: "https://www.adobe.com/go/dcdg_samplereceipt",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[4],
  },
  {
    id: 14,
    name: "Sales Order",
    description:"Sales Order",
    icon: `${baseUrl}/img/template-icons/sales_order.jpg`,
    discover: "https://www.adobe.com/go/dcdg_samplesalesorder",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[4],
  },
  {
    id: 15,
    name: "Investment Proposal Letter",
    description:"Investment Proposal Letter",
    icon: `${baseUrl}/img/template-icons/investment_proposal.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleinvestmentproposalletter",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[4],
  },
  {
    id: 16,
    name: "Mortgage Proposal",
    description:"Investment Proposal Letter",
    icon: `${baseUrl}/img/template-icons/mortgage_proposal.jpg`,
    discover: "https://www.adobe.com/go/dcdg_samplemortgageproposal",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[4],
  },
  {
    id: 17,
    name: "Purchase Order",
    description:"Investment Proposal Letter",
    icon: `${baseUrl}/img/template-icons/purchase_order.jpg`,
    discover: "https://www.adobe.com/go/dcdg_samplepurchaseorder",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[4],
  },
  {
    id: 18,
    name: "Affidavit of Identity",
    description:"Affidavit of Identity",
    icon: `${baseUrl}/img/template-icons/affidavit-of-identity.jpg`,
    discover: "https://adobe.com/go/dcdgsampleaffidavitofidentity",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 19,
    name: "Child Support",
    description:"Child Support",
    icon: `${baseUrl}/img/template-icons/child-support-agreement.jpg`,
    discover: "https://adobe.com/go/dcdgsamplechildsupport",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 20,
    name: "Clinical Trial",
    description:"Clinical Trial",
    icon: `${baseUrl}/img/template-icons/clinical-trial-consent.jpg`,
    discover: "https://adobe.com/go/dcdgsampleclinicaltrial",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 21,
    name: "Consulting Agreement",
    description:"Consulting Agreement",
    icon: `${baseUrl}/img/template-icons/consulting-agreement.jpg`,
    discover: "https://adobe.com/go/dcdgsampleconsultingagreement",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 22,
    name: "Liability Consent Form",
    description:"Liability Consent Form",
    icon: `${baseUrl}/img/template-icons/welcome_kit.jpg`,
    discover: "https://adobe.com/go/dcdgsampleliabilityconsentform",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 23,
    name: "Liability Release Form",
    description:"Liability Release Form",
    icon: `${baseUrl}/img/template-icons/liability-release.jpg`,
    discover: "https://adobe.com/go/dcdgsampleliabilityreleaseform",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 24,
    name: "License Agreement",
    description:"License Agreement",
    icon: `${baseUrl}/img/template-icons/licensing-agreeemnt.jpg`,
    discover: "https://adobe.com/go/dcdgsamplelicenseagreement",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 25,
    name: "Living Trust",
    description:"Living Trust",
    icon: `${baseUrl}/img/template-icons/living-trust.jpg`,
    discover: "https://adobe.com/go/dcdgsamplelivingtrust",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 26,
    name: "Loan Agreement",
    description:"Loan Agreement",
    icon: `${baseUrl}/img/template-icons/loan-agreement.jpg`,
    discover: "https://adobe.com/go/dcdgsampleloanagreement",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 27,
    name: "Non-Disclosure Agreements",
    description:"Non-Disclosure Agreements",
    icon: `${baseUrl}/img/template-icons/nda.jpg`,
    discover: "https://adobe.com/go/dcdgsamplenda",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 28,
    name: "Partnership Agreement",
    description:"Partnership Agreement",
    icon: `${baseUrl}/img/template-icons/partnership-agreement.jpg`,
    discover: "https://adobe.com/go/dcdgsamplepartnershipagreement",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 29,
    name: "Rental Agreement",
    description:"Rental Agreement",
    icon: `${baseUrl}/img/template-icons/rental-agreement.jpg`,
    discover: "https://adobe.com/go/dcdgsamplerentalagreement",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 30,
    name: "Terms and Conditions",
    description:"Terms and Conditions",
    icon: `${baseUrl}/img/template-icons/terms-conditions.jpg`,
    discover: "https://adobe.com/go/dcdgsampletermsnconditions",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 31,
    name: "Catering Invoice",
    description:"Catering Invoice",
    icon: `${baseUrl}/img/template-icons/catering-invocie.jpg`,
    discover: "https://adobe.com/go/dcdgsamplecateringinvoice",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 32,
    name: "Credit Memo",
    description:"Terms and Conditions",
    icon: `${baseUrl}/img/template-icons/credit-memo.jpg`,
    discover: "https://adobe.com/go/dcdgsamplecreditmemo",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 33,
    name: "Executive Summary",
    description:"Executive Summary",
    icon: `${baseUrl}/img/template-icons/executive-summary.jpg`,
    discover: "https://adobe.com/go/dcdgsampleexecutivesummary",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 34,
    name: "Press Release",
    description:"Press Release",
    icon: `${baseUrl}/img/template-icons/press-release.jpg`,
    discover: "https://adobe.com/go/dcdgsamplepressrelease",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 35,
    name: "Restaurant Menu",
    description:"Restaurant Menu",
    icon: `${baseUrl}/img/template-icons/restaurant-menu.jpg`,
    discover: "https://adobe.com/go/dcdgsamplerestaurantmenu",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 36,
    name: "White Paper",
    description:"White Paper",
    icon: `${baseUrl}/img/template-icons/white-paper.jpg`,
    discover: "https://adobe.com/go/dcdgsamplewhitepaper",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[1],
  },
  {
    id: 37,
    name: "Add/Drop Audit Form",
    description:"Add/Drop Audit Form",
    icon: `${baseUrl}/img/template-icons/add-drop-audit-form.jpg`,
    discover: "https://adobe.com/go/dcdgsampleaddropform",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[2],
  },
  {
    id: 38,
    name: "Attendance Sheet",
    description:"Attendance Sheet",
    icon: `${baseUrl}/img/template-icons/attendance-sheet.jpg`,
    discover: "https://adobe.com/go/dcdgsampleattendancesheet",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[2],
  },
  {
    id: 39,
    name: "High School Catalog",
    description:"High School Catalog",
    icon: `${baseUrl}/img/template-icons/high-school-catalog.jpg`,
    discover: "https://adobe.com/go/dcdgsamplehighschoolcatalog",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[2],
  },
  {
    id: 40,
    name: "Student Submission",
    description:"Student Submission",
    icon: `${baseUrl}/img/template-icons/student-submission.jpg`,
    discover: "https://adobe.com/go/dcdgsamplestudentsubmission",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[2],
  },
  {
    id: 41,
    name: "Change of Beneficiary",
    description:"Change of Beneficiary",
    icon: `${baseUrl}/img/template-icons/change-of-benificiary.jpg`,
    discover: "https://adobe.com/go/dcdgsamplechangebeneficiary",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[3],
  },
  {
    id: 42,
    name: "Salary Verification",
    description:"Salary Verification",
    icon: `${baseUrl}/img/template-icons/salary-verification-letter.jpg`,
    discover: "https://adobe.com/go/dcdgsamplesalaryverification",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[3],
  },
  {
    id: 43,
    name: "Standard Operation Procedure",
    description:"Standard Operation Procedure",
    icon: `${baseUrl}/img/template-icons/sop.jpg`,
    discover: "https://adobe.com/go/dcdgsamplestandardoperationprocedure",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[3],
  },
  {
    id: 44,
    name: "Travel Consent Form",
    description:"Travel Consent Form",
    icon: `${baseUrl}/img/template-icons/travel-consent-form.jpg`,
    discover: "https://adobe.com/go/dcdgsampletravelconsentform",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[3],
  },
  {
    id: 45,
    name: "Eligibility of Sale",
    description:"Eligibility of Sale",
    icon: `${baseUrl}/img/template-icons/agreement.jpg`,
    discover: "https://adobe.com/go/dcdgsamplebillofsale",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[4],
  },
  {
    id: 46,
    name: "Service Receipt",
    description:"Service Receipt",
    icon: `${baseUrl}/img/template-icons/service_receipt.jpg`,
    discover: "https://adobe.com/go/dcdgsampleservicereceipt",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[4],
  },
  {
    id: 47,
    name: "Shipping Notice",
    description:"Shipping Notice",
    icon: `${baseUrl}/img/template-icons/shipping-notice.jpg`,
    discover: "https://adobe.com/go/dcdgsampleshippingnotice",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[4],
  },
  {
    id: 48,
    name: "Stock Sale and Purchase",
    description:"Stock Sale and Purchase",
    icon: `${baseUrl}/img/template-icons/stock-sale-purchase.jpg`,
    discover: "https://adobe.com/go/dcdgsamplestocksaleandpurchase",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[4],
  }
];

const sampleProducts = [
  {
    id: 0,
    name: "Agreement",
    description: "Adobe Creative Cloud APIs and SDKs enable developers",
    icon: `${baseUrl}/img/template-icons/agreement.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleagreement",
    docs: false,
    lastUpdated: "2020",
    cloud: clouds[0],
  },
  {
    id: 1,
    name: "Grant application",
    description:
      "The Libraries API lets you connect your app to Creative Cloud and expand the reach of your users' creative systems.",
    icon: `${baseUrl}/img/template-icons/grant_application.jpg`,
    discover: "https://www.adobe.com/go/dcdg_samplegrant",
    docs: false,
    lastUpdated: "2019",
    cloud: clouds[4],
  },
  {
    id: 2,
    name: "Invoice",
    description:
      "Adobe XD’s powerful API platform lets developers and users extend XD within the app, or in the cloud.",
    icon: `${baseUrl}/img/template-icons/invoice.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleinvoice",
    docs: false,
    lastUpdated: "2017",
    cloud: clouds[4],
  },
  {
    id: 3,
    name: "Sample proposal",
    description: "Give your users access to the perfect Adobe Stock",
    icon: `${baseUrl}/img/template-icons/proposal_letter.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleproposal",
    docs: false,
    lastUpdated: "2002",
    cloud: clouds[4],
  },
  {
    id: 4,
    name: "Certification report",
    description:
      "With Photoshop APIs and SDKs, build plugins and integrations that harness the power of the world's best image editing",
    icon: `${baseUrl}/img/template-icons/lms_report.jpg`,
    discover: "https://www.adobe.com/go/dcdg_samplereport",
    docs: false,
    lastUpdated: "2018",
    cloud: clouds[0],
  },
  {
    id: 5,
    name: "Offer Letter",
    description: "Create effects, define presets and brushes, manipu",
    icon: `${baseUrl}/img/template-icons/offer_letter.jpg`,
    discover: "https://www.adobe.com/go/dcdg_sampleofferletter",
    docs: false,
    lastUpdated: "1999",
    cloud: clouds[0],
  }
];

module.exports = {
  clouds,
  products,
  sampleProducts
};